// src/features/mensagens/routes.jsx
// ============================================================================
// 🧭 RUTAS DEL FEATURE MENSAGENS
// 📦 V2 ENTERPRISE — Imports Directos · Mobile-First · Anti-Suspense Bug
// ============================================================================
//
// REGLAS DE ORO:
// 1. Este archivo define TODAS las rutas de mensagens
// 2. App.jsx solo importa <MensagensRoutes /> (una línea)
// 3. Rutas anidadas comparten Layout y estado
// 4. V2: Imports directos en vez de lazy() — soluciona bug de eventos en React 18
// 5. Transiciones nativas entre lista y detalle en mobile
// 6. Compatible 100% con App.jsx actual — Zero ruptura
// ============================================================================

import React from 'react';
import { Route, Routes } from 'react-router-dom';

// ============================================================================
// 📦 IMPORTS DIRECTOS — V2: Sin lazy loading para evitar bug de eventos
// ============================================================================
//import MensagensLista from './TestMensagens';
import MensagensLista from './components/lista/MensagensLista';
import ChatView from './components/chat/ChatView';

// ============================================================================
// 🚨 ERROR BOUNDARY — Protección contra crashes
// ============================================================================

class LazyErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-64 text-gray-500 gap-3">
          <p className="text-lg font-medium">Erro ao carregar</p>
          <p className="text-sm text-gray-400">
            {this.state.error?.message || 'Tente recarregar a página'}
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-xl text-sm font-medium
                       hover:bg-blue-700 transition-colors"
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// ============================================================================
// 🧭 RUTAS
// ============================================================================

/**
 * Componente de rutas del feature Mensagens
 *
 * Estructura:
 * /mensagens                 → Lista de conversaciones (tipo WhatsApp)
 * /mensagens/:conversationId → Chat individual con un cliente
 *
 * Uso en App.jsx:
 *   import { MensagensRoutes } from './features/mensagens/routes';
 *   <Route path="/mensagens/*" element={<MensagensRoutes />} />
 */
export function MensagensRoutes() {
  return (
    <LazyErrorBoundary>
      <Routes>
        {/* Lista principal de conversaciones (vista WhatsApp) */}
        <Route
          index
          element={<MensagensLista />}
        />

        {/* Chat individual con un cliente */}
        <Route
          path=":conversationId"
          element={<ChatView />}
        />

        {/* 404 dentro de /mensagens */}
        <Route
          path="*"
          element={
            <div className="flex flex-col items-center justify-center h-64 text-gray-500 gap-2">
              <p className="text-lg font-medium">Página não encontrada</p>
              <p className="text-sm text-gray-400">
                Esta seção de mensagens não existe
              </p>
            </div>
          }
        />
      </Routes>
    </LazyErrorBoundary>
  );
}

// ============================================================================
// 📤 EXPORTACIÓN DEFAULT
// ============================================================================

export default MensagensRoutes;